// @flow

import type {MarkdocTagRegistration} from 'docs/markdoc';

export const PlaylistPlayer: MarkdocTagRegistration = {
  tag: 'playlist-player',
  component: 'PlaylistPlayer',

  attributes: {
    playlist: {type: String, required: true},
    settings: {
      type: String,
      required: true,
      matches: [
        'default',
        'server-only',
        'web-only',
        'web-with-next',
        'terminal',
      ],
    },
    title: {type: String, required: true, localizable: true},
  },
};
